import { flightReducerById } from './views/FlightDetailsView/ducks';
import { reducer as createReducer } from './views/Create/ducks';
import currentUserDetailsReducersMapObject from '@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer';
import { combineReducers } from 'redux';
export const moduleReducer = Object.assign({ flightModule: combineReducers({
        details: flightReducerById,
        create: createReducer,
    }) }, currentUserDetailsReducersMapObject);
export default moduleReducer;

//# sourceMappingURL=reducers.js.map
